module.exports = __webpack_public_path__ + "img/mechanics_sign.02031440.png";